"use client";
import { useRouter } from "next/navigation";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { useCallback } from "react";

// Car Wash ID
const CAR_WASH_ID = "695127c56183535423530a70";

const CarWash = React.memo(function CarWash({ carWashData, loading, onBookNow }) {
  const router = useRouter();

  const handleBookNowClick = useCallback(() => {
    if (typeof onBookNow === "function") {
      onBookNow();
      return;
    }
    router.push(`/subcategory/${CAR_WASH_ID}`);
  }, [onBookNow, router]);

  // Get the name and description from the fetched data
  const name = carWashData?.name || "Car and Bike Cleaning Services";
  const description = carWashData?.offerings?.[0]?.name || "Professional car and bike wash";

  if (loading) {
    return (
      <div className="flex justify-center mb-6 px-3">
        <div className="w-full max-w-[650px] rounded-[24px] bg-gradient-to-r from-[#FF7043] to-[#FFB74D] p-4 xs:p-5 sm:p-5 flex items-center justify-center gap-3 animate-pulse">
          <span className="text-white text-sm">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center mb-6 px-3">
      <div 
        onClick={handleBookNowClick}
        className="w-full max-w-[650px] h-24 rounded-[16px] bg-gradient-to-r from-[#FF7043] to-[#FFB74D] p-4 xs:p-5 sm:p-5 flex items-center justify-between gap-3 cursor-pointer hover:shadow-lg transition-all duration-200"
      >
        {/* Left side with icon and text */}
        <div className="flex items-center gap-3 xs:gap-4 min-w-0 flex-1">
          <div className="w-12 h-12 xs:w-14 xs:h-14 sm:w-16 sm:h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
            <DirectionsCarIcon className="h-6 w-6 xs:h-7 xs:w-7 sm:h-8 sm:w-8 text-white" />
          </div>
          <div className="flex flex-col min-w-0 flex-1">
            <span className="text-white text-base xs:text-md sm:text-xl font-semibold ">
              {name}
            </span>
            <span className="text-white/90 text-sm xs:text-base sm:text-base">
              {description}
            </span>
          </div>
        </div>
        
        {/* Right arrow */}
        <div className="w-8 h-8 xs:w-9 xs:h-9 sm:w-10 sm:h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
          <ChevronRightIcon className="h-5 w-5 xs:h-6 xs:w-6 text-white" />
        </div>
      </div>
    </div>
  );
});

// Export the ID so parent can use it for fetching
export { CAR_WASH_ID };
export default CarWash;
